var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProcess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49004 20H7.45671C5.8518 20 5.04935 20 4.41635 20.2283C3.57237 20.5328 2.90182 21.1169 2.55223 21.8519C2.29004 22.4033 2.29004 23.1021 2.29004 24.5C2.29004 25.8979 2.29004 26.5967 2.55223 27.1481C2.90182 27.8831 3.57237 28.4672 4.41635 28.7717C5.04935 29 5.8518 29 7.45671 29H28.1234C29.7283 29 30.5307 29 31.1638 28.7717C32.0077 28.4672 32.6783 27.8831 33.0279 27.1481C33.29 26.5967 33.29 25.8979 33.29 24.5C33.29 23.1021 33.29 22.4033 33.0279 21.8519C32.6783 21.1169 32.0077 20.5328 31.1638 20.2283C30.5307 20 29.7283 20 28.1234 20H27.09M17.79 11V23M17.79 23L14.3456 20M17.79 23L21.2345 20M7.45671 11H28.1234C29.7283 11 30.5307 11 31.1638 10.7716C32.0077 10.4672 32.6783 9.88313 33.0279 9.14805C33.29 8.59673 33.29 7.89782 33.29 6.5C33.29 5.10218 33.29 4.40327 33.0279 3.85195C32.6783 3.11687 32.0077 2.53285 31.1638 2.22836C30.5307 2 29.7283 2 28.1234 2H7.45671C5.8518 2 5.04935 2 4.41635 2.22836C3.57237 2.53285 2.90182 3.11687 2.55223 3.85195C2.29004 4.40327 2.29004 5.10218 2.29004 6.5C2.29004 7.89782 2.29004 8.59673 2.55223 9.14805C2.90182 9.88313 3.57237 10.4672 4.41635 10.7716C5.04935 11 5.8518 11 7.45671 11Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcess);
export default __webpack_public_path__ + "static/media/icon-process.9edad730c82f6cfe153ac9db0bd5a489.svg";
export { ForwardRef as ReactComponent };